// extracted by mini-css-extract-plugin
export var chip = "_47-0";
export var filterDropdown = "_47-5";
export var filterItem = "_47-6";
export var icon = "_47-1";
export var removeButton = "_47-3";
export var removeIcon = "_47-4";
export var separator = "_47-2";